<template>
    <div class="mt-4 pt-4">
      <h3><strong>Certificate</strong></h3>
        <div class="">
            <div class="row">
                <div class="col-md-12">
                    <div class="card strpied-tabled-with-hover">
                        <div class="card-body">
                          <button class="btn btn-outline-info rounded-pill btn-lg me-3" v-on:click="generateCertificate()">Generate certificate</button>

                          <button
                            class="btn btn-outline-info rounded-pill btn-lg"
                            v-on:click="downloadCertificate()"
                            v-if="numPages > 0"
                          >Download Certificate</button>

                            <div class="mt-4" v-if="numPages > 0">
                              <pdf
                                class="m-auto"
                                v-for="i in numPages"
                                :key="i"
                                :src="src"
                                :page="i"
                                dpi="50"
                                style="width:65%"
                                ref="pdfViewer"
                              ></pdf>
                            </div>
                            <div class="mt-4" v-else>
                              <p>No certificate found</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import pdf from 'vue-pdf'
  export default {
    components: {
      pdf
    },
    data () {
      return {
        src: '',
        numPages: 0,
        active: 0,
        project_id : this.$route.params.prod_id,
        org_id : this.$route.params.org_id,
        selection: 'completed'
      }
    },
    mounted() {
      var me = this;
      setTimeout(function(){
        me.init();
      },1000);
    },
    methods: {
      async init() {
        try {
          const url = this.$server + 'organisation/'+ this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/reports/certificate';
          const response = await this.$axios.get(url, { responseType: 'arraybuffer' });

          // vue-pdf can load from a typed array
          this.src = new Uint8Array(response.data);

          // We need to get the number of pages from the created task
          pdf.createLoadingTask(this.src).promise.then(pdf => {
            this.numPages = pdf.numPages;
          });
        } catch (error) {
            if(error.response.status != 404){
              this.$toast.error("Could not load certificate.");
            }
            this.numPages = 0;
        }
      },

      generateCertificate() {
        this.$axios.get(
          this.$server + 'organisation/'+ this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/reports/certificate/generate'
        )
        .then(res => {
          var r = res.data;
          if (r.success) {
            this.$swal({
                title: "Certificate has been successfully generated."
            });
            this.init();
          } else {
            this.$swal({
                title: r.message,
                icon: "error"
            });
          }
        });
      },

      downloadCertificate() {
        var url = this.$server + 'organisation/'+ this.$route.params.org_id + '/project/' + this.$route.params.prod_id + '/reports/certificate';
        this.$axios.get(url, {
              responseType: 'blob',
              crossDomain: true
          }).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', 'certificate.pdf');
            document.body.appendChild(link);
            link.click();
          });
      }

    }
  }
</script>